import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";
import Home from "./pages/Home";
import Services from "./pages/Services";
import PricesMobile from "./pages/PricesMobile";
import PricesApple from "./pages/PricesApple";
import PricesSamsung from "./pages/PricesSamsung";
import PricesHuawei from "./pages/PricesHuawei";
import PricesPC from "./pages/PricesPC";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tjenester" element={<Services />} />
            <Route path="/priser/mobil" element={<PricesMobile />} />
            <Route path="/priser/mobil/apple" element={<PricesApple />} />
            <Route path="/priser/mobil/samsung" element={<PricesSamsung />} />
            <Route path="/priser/mobil/huawei" element={<PricesHuawei />} />
            <Route path="/priser/pc" element={<PricesPC />} />
            <Route path="/om-oss" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCallButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
